export default class PaWorkController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWork/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWork/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/paWork/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWork/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWork/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWork/delete', 'post', params, axiosOption, httpOption);
  }

  static startOnlyPaWorkApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWork/startOnly/PaWorkApprovalFlow', 'post', params, axiosOption, httpOption);
  }

  static startWithBusinessKeyPaWorkApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWork/startWithBusinessKey/PaWorkApprovalFlow', 'post', params, axiosOption, httpOption);
  }

  static startAndTakeUserTaskPaWorkApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWork/startAndTakeUserTask/PaWorkApprovalFlow', 'post', params, axiosOption, httpOption);
  }

  static submitUserTaskPaWorkApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWork/submitUserTask/PaWorkApprovalFlow', 'post', params, axiosOption, httpOption);
  }

  static viewTaskBusinessDataPaWorkApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWork/viewTaskBusinessData/PaWorkApprovalFlow', 'get', params, axiosOption, httpOption);
  }

  static viewHistoricTaskBusinessDataPaWorkApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWork/viewHistoricTaskBusinessData/PaWorkApprovalFlow', 'get', params, axiosOption, httpOption);
  }

  static listWorkOrderPaWorkApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paWork/listWorkOrder/PaWorkApprovalFlow', 'post', params, axiosOption, httpOption);
  }
}
